const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Q8-4 (director 13 Oct 2026): every admin date in Perth time (AWST = UTC+8, no daylight saving), month as a word, e.g. "11 Oct 2026, 5:20 pm AWST".
export const formatAwst = (iso) => {
  if (!iso) return '—';
  const p = new Date(iso);
  if (Number.isNaN(p.getTime())) return String(iso);
  const t = new Date(p.getTime() + 8 * 60 * 60 * 1000);
  const h = t.getUTCHours(), m = String(t.getUTCMinutes()).padStart(2, '0');
  return `${t.getUTCDate()} ${MONTHS[t.getUTCMonth()]} ${t.getUTCFullYear()}, ${h % 12 || 12}:${m} ${h < 12 ? 'am' : 'pm'} AWST`;
};
